export default __webpack_public_path__ + "static/media/OU.0a1d4fc8.svg";